import { Navigate } from "react-router-dom"
import { useAuth } from "@/context/AuthContext"
import { isWelcomeSeen } from "@/lib/welcomeSeen"

export default function EntryRedirect() {
  const { isAuthenticated, isBootstrapping } = useAuth()

  if (isBootstrapping) {
    return (
      <div className="flex min-h-dvh flex-col items-center justify-center gap-3 bg-guardians-bg">
        <div className="h-10 w-10 animate-spin rounded-full border-2 border-guardians-accent border-t-transparent" />
        <p className="text-sm text-guardians-muted">Хранители</p>
      </div>
    )
  }

  if (isAuthenticated) {
    return <Navigate to="/play" replace />
  }

  if (!isWelcomeSeen()) {
    return <Navigate to="/welcome" replace />
  }

  return <Navigate to="/login" replace />
}
